<p-confirmDialog />
<app-main-header></app-main-header>

@if ((breadcrumbs$ | async)?.length) {
<nav class="breadcrumb-bar no-print" aria-label="breadcrumb">
  <p-breadcrumb [home]="breadcrumbHome" [model]="(breadcrumbs$ | async) || []" styleClass="border-0 bg-transparent py-1 px-3" />
</nav>
}

<main>
  <div class="app-header"></div>
  <div class="app-sidebar"></div>
  <router-outlet></router-outlet>
</main>
